/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PatchManagementAzureErrorContext {
    getFixupPrototypeFunction() { return PatchManagementAzureErrorContext.fixupPrototype; }

    static newInstance(model: Partial<PatchManagementAzureErrorContext>): PatchManagementAzureErrorContext {
        let obj = Object.assign(new PatchManagementAzureErrorContext(), model);
        PatchManagementAzureErrorContext.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PatchManagementAzureErrorContext>): PatchManagementAzureErrorContext {
        if (!model) return null;
        return PatchManagementAzureErrorContext.newInstance(<PatchManagementAzureErrorContext> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PatchManagementAzureErrorContext) {
        if (!obj) return;

        models.PatchManagementAzureErrorContext.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PatchManagementAzureErrorContext): boolean {
        Object.setPrototypeOf(obj, PatchManagementAzureErrorContext.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Error message
     */
    message: string;

    /**
     * Error code
     */
    code: string;

}
